

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL= createAsyncThunk(
  "bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel/bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice = createSlice({
  name: "bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice",
  initialState: {
    bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel: (state) => {
        state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel.loading = false
        state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel.error = false
        state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel.data = []
        state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL.fulfilled, (state, action) => {
      state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel = {
        ...state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL.pending, (state, action) => {
      state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel = {
        ...state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL.rejected, (state, action) => {
      state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel = {
        ...state.bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelAction = {
    BULKUPDATEKRAKPIANSWERSOFMANAGERANDREVIEWEREVALUTATIONFROMEXCEL,
};

export { bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelAction };
export default bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice.reducer;
export const {setInitialStateOfbulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcel} = bulkUpdateKraKpiAnswersOfManagerAndReviewerEvalutationFromExcelSlice.actions
